import React from 'react'

type Props = {
  className?: string
  title?: string
  icon?: any
  list?: any
}

const DropdownIcon: React.FC<Props> = ({className, title, icon, list, children}) => {
  return (
    <>
      <button
        type='button'
        className={className}
        data-kt-menu-trigger='click'
        data-kt-menu-overflow='true'
        data-kt-menu-placement='bottom-end'
      >
        {icon}
      </button>
      <div
        className='menu menu-sub menu-sub-dropdown menu-rounded menu-gray-800 menu-state-bg-light-primary fw-bold'
        data-kt-menu='true'
      >
        {title && (
          <div className='menu-item px-3'>
            <div className='menu-content fs-6 text-dark fw-bolder px-3 py-4'>{title}</div>
          </div>
        )}
        <div className='separator mb-3 opacity-75' />
        {list &&
          list.map((child: any, index: number) => (
            <div className='menu-item px-3' key={index}>
              <span onClick={child?.action} className='menu-link px-3'>
                {child.label}
              </span>
            </div>
          ))}
        {children}
        <div className='separator mt-3 opacity-75' />
      </div>
    </>
  )
}

export {DropdownIcon}
